import { Grid } from '@mui/material';

import { MetaTags } from '@redwoodjs/web';

import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { CommissionType } from 'src/features/finance/commissionStatement/constants/commissionType';
import useViewCommissionStatement from 'src/features/finance/commissionStatement/hooks/useViewCommissionStatement';
import commissionStatementsGridColDefs from 'src/features/finance/commissionStatement/utils/commissionStatementsTableColDef';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

type ViewCommissionsPageInput = {
    commissionType: CommissionType;
};

const ViewCommissionsPage = ({ commissionType }: ViewCommissionsPageInput) => {
    const {
        tableData,
        loading,
        commissionTypeCamelCase,
        commissionTypeLowerCase,
        handleViewCommission,
    } = useViewCommissionStatement({ commissionType });

    return (
        <PageContent
            heading={`${commissionTypeCamelCase} Commissions`}
            subHeading={`${commissionTypeCamelCase} Commissions`}
        >
            <MetaTags
                title={`${commissionTypeCamelCase}Commissions`}
                description={`${commissionTypeCamelCase} Commissions page`}
            />
            {loading || !tableData ? (
                <Loader />
            ) : (
                <Grid container sx={{ gap: '24px' }}>
                    <Grid item xs={12}>
                        <NPIDataGrid
                            rows={tableData}
                            columns={commissionStatementsGridColDefs()}
                            getRowId={(row) => {
                                return row.id;
                            }}
                            handleView={({ id }) => {
                                handleViewCommission(id);
                            }}
                            title={`${commissionTypeCamelCase} Commissions Page`}
                            dataTestId={`${commissionTypeLowerCase}-commissions-page-table`}
                        />
                    </Grid>
                </Grid>
            )}
        </PageContent>
    );
};
export default ViewCommissionsPage;
